import armSvg from '@legit-health/svg-images/images/instructions/arm.svg';
import moleSvg from '@legit-health/svg-images/images/instructions/mole.svg';
import {Box, Typography} from '@mui/material';
import {TFunction} from 'i18next';
import {UseFormReturn, useWatch} from 'react-hook-form';
import StepTitle from '@/components/StepTitle';
import FormValues from '../../../../interfaces/FormValues';

const options = [
  {
    key: 'localized',
    img: moleSvg
  },
  {
    key: 'other',
    img: armSvg
  }
];

export default function LesionTypeField({
  t,
  form
}: {
  t: TFunction;
  form: UseFormReturn<FormValues>;
}) {
  const lesionType = useWatch({
    control: form.control,
    name: 'lesionType'
  });

  return (
    <Box>
      <StepTitle title={t('app:lesionType.title')} subtitle={t('app:lesionType.subtitle')} />
      {options.map(({key, img}) => (
        <Box
          key={key}
          data-testid={key}
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: 1,
            mb: 1,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: lesionType === key ? 'primary.main' : 'grey.400',
            borderRadius: 1,
            cursor: 'pointer',
            opacity: lesionType && lesionType !== key ? 0.4 : 1
          }}
          onClick={() => form.setValue('lesionType', key)}
        >
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: 48,
                height: 48,
                mr: 2,
                borderRadius: 1,
                '& > img': {
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 1
                }
              }}
            >
              <img src={img} />
            </Box>
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">
                {t(`app:lesionType.options.${key}.label`)}
              </Typography>
              <Typography variant="body2">
                {t(`app:lesionType.options.${key}.description`)}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
